import { ErrorBarController } from './errorBar.controller';
import template from './errorBar.html';

export const errorBarComponent = {
  name: 'errorBar',
  restrict: 'E',
  template,
  controller: ErrorBarController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-error-handling/src/errorBar/errorBar.component.js